import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
    selector: 'app-cut-card',
    imports: [CommonModule],
    templateUrl: './cut-card.component.html',
    styleUrl: './cut-card.component.scss'
})
export class CutCardComponent {}
